/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_Pdf_UploadInputs */

const en_homepage_features_upload_pdf_upload = /** @type {(inputs: Homepage_Features_Upload_Pdf_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF Upload`)
};

const es_homepage_features_upload_pdf_upload = /** @type {(inputs: Homepage_Features_Upload_Pdf_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir PDF`)
};

/**
* | output |
* | --- |
* | "PDF Upload" |
*
* @param {Homepage_Features_Upload_Pdf_UploadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_pdf_upload = /** @type {((inputs?: Homepage_Features_Upload_Pdf_UploadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_Pdf_UploadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_pdf_upload(inputs)
	return en_homepage_features_upload_pdf_upload(inputs)
});